module.exports = __webpack_public_path__ + "static/media/Azure Rathalos.e675a1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Azure Rathalos.png
// module id = 94
// module chunks = 0